<template>
  <div
    v-if="has_match_page_store"
    :class="[
      'fg-container roi-component',
      { 'waf-menu-card': activeModule === 'GAME_PLAN' },
      { 'waf-lineup': activeModule === 'LINEUP' },
      { 'waf-match-info': (activeModule === 'MATCH_INFO' || activeModule === 'MATCH_INFO_AMP') },
      { 'waf-scorecard': activeModule === 'SCORECARD' },
    ]"
  >
    <top-section
      v-if="!isLoading"
      :isAmp="isAmp"
      :parentRoute="parentRoute"
      :loaded_module="loaded_module"
      :breadcrumbTransKey="getBreadcrumbTrans()"
    />
    <contest-parent
      v-if="activeModule === 'GAME_PLAN'"
      :parentRoute="parentRoute"
    />
    <teams-parent
      v-if="activeModule === 'LINEUP'"
      :parentRoute="parentRoute"
    />
    <fantasy-tips-parent
      v-if="activeModule === 'MATCH_INFO'"
      :parentRoute="parentRoute"
    />
    <amp-fantasy-tips-parent
      v-if="activeModule === 'MATCH_INFO_AMP'"
      :parentRoute="parentRoute"
    />
    <scorecard-parent
      v-if="activeModule === 'SCORECARD'"
      :parentRoute="parentRoute"
    />
  </div>
</template>
<script>
import { cssImport, getMatch } from '../../assets/js/common';
import { CFG_MODULES } from "../../assets/js/config";
import MatchDetailStore from "../../store/modules/matchDetails/matchDetailsStore";
import MatchDetailTopSection from "./topSection/MatchDetailTopSection";
const ContestParent = () =>
  import(/* webpackChunkName: "contest" */ "./contests/ContestParent");
const TeamsParent = () =>
  import(/* webpackChunkName: "teams" */ "./teams/TeamsParent");
const FantasyTipsParent = () =>
  import(
    /* webpackChunkName: "fantasy-tips" */ "./fantasyTips/FantasyTipsParent"
  );
const AmpFantasyTipsParent = () =>
  import(
    /* webpackChunkName: "fantasy-tips-amp" */ "./fantasyTips/AmpFantasyTipsParent"
  );
const ScorecardParent = () =>
  import(/* webpackChunkName: "scorecard" */ "./scorecard/ScorecardParent");

export default {
  props: ["moduleName", "isAmp"],
  components: {
    topSection: MatchDetailTopSection,
    ContestParent,
    TeamsParent,
    FantasyTipsParent,
    AmpFantasyTipsParent,
    ScorecardParent,
  },
  data() {
    return {
      parentRoute: CFG_MODULES[this.moduleName].route,
      loaded_module: CFG_MODULES[this.moduleName].name,
    };
  },
  computed: {
    has_match_page_store() {
      return !!(this.$store.state && this.$store.state.match_detail_store && this.$store.state.match_detail_store.match_store_filled);
    },
    isLoading() {
      return this.$store.state.match_detail_store.isLoading;
    },
    activeModule() {
      return this.$store.state.match_detail_store.activeModule;
    },
    translations() {
      return this.$store.state.translations;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    isLiveScoringActive() {
      return this.$store.state.match_detail_store.isLiveScoringActive;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("match_detail_store", MatchDetailStore);
    if(this.moduleName === 'MATCH_INFO' && this.isAmp) {
      await this.$store.dispatch("match_detail_store/setActiveModule", "MATCH_INFO_AMP");  
    } else {
      await this.$store.dispatch("match_detail_store/setActiveModule", this.moduleName);
    }
    await this.$store.dispatch("match_detail_store/fetchMatchData");
  },
  beforeMount() {
    this.registerMatchDetailStore();
    if(!this.activeModule) {
      if(this.moduleName === 'MATCH_INFO' && this.isAmp) {
        this.$store.dispatch("match_detail_store/setActiveModule", "MATCH_INFO_AMP");  
      } else {
        this.$store.dispatch("match_detail_store/setActiveModule", this.moduleName);
      }
    }
  },
  mounted() {
    let hasStore = this.has_match_page_store;
    if (!hasStore) {
      cssImport(["/static-assets/css/fg-top-widget.css"]);
    }
    if(!(hasStore && this.moduleName === 'LINEUP')) {
      // ignore call when lineup data comes from server side. Lineup module condition is applied because polling is already activated there.
      if(hasStore){
        setTimeout(() => {
          // to avoid LCP and LTS issues we call refreshing data after 5 seconds
          this.callApis();
        }, 5000);
      } else {
        this.callApis();
      }
    }
  },
  methods: {
    registerMatchDetailStore() {
      let hasMatchDetailStore = this.$store.hasModule("match_detail_store");
      if (!hasMatchDetailStore) {
        this.$store.registerModule("match_detail_store", MatchDetailStore, {
          preserveState: this.has_match_page_store,
        });
      }
    },
    async callApis() {
      await Promise.all([
        this.$store.dispatch("match_detail_store/fetchMatchData"),
      ]);
    },
    getBreadcrumbTrans() {
      if(this.activeModule === 'GAME_PLAN') {
        return 'contests_headline';
      } else if(this.activeModule === 'LINEUP') {
        return 'lineup_headline';
      } else if(this.activeModule === 'SCORECARD') {
        let key = `scorecard_headline_1`;
        if(this.current_match && this.current_match.sport_id) {
          let transKey = `scorecard_headline_${this.current_match.sport_id}`;
          if(this.isLiveScoringActive){
            transKey = `scorecard_headline_live_${this.current_match.sport_id}`;
          }
          if(this.translations[transKey]) {
            key = transKey;
          }
        }
        
        return key;
      } else {
        return 'match_tips_headline'; 
      }
    }
  },
  beforeDestroy() {
    // reset match details
  },
  unmounted() {
    let hasMatchDetailStore = this.$store.hasModule("match_detail_store");
    if (hasMatchDetailStore) {
      this.$store.unregisterModule("match_detail_store");
    }
  },
};
</script>